var map = {
	"./wenus1.jpg": 8810,
	"./wenus2.jpg": 220,
	"./wenus3.jpg": 4640,
	"./wenus4.jpg": 9624,
	"assets/photo/fashion-photography/wenus/wenus1.jpg": 8810,
	"assets/photo/fashion-photography/wenus/wenus2.jpg": 220,
	"assets/photo/fashion-photography/wenus/wenus3.jpg": 4640,
	"assets/photo/fashion-photography/wenus/wenus4.jpg": 9624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3584;